// extracted by mini-css-extract-plugin
module.exports = {"cardTop":"CrossSegmentCard-CardTop-module--card-top--2OKbP"};